<script>
import { mapState, mapActions } from 'vuex';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'RequestsList',
  mixins: [
    dateMixin,
  ],
  data() {
    return {
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Channel', value: 'channel', sortable: false },
        { text: 'Type', value: 'requestType', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Product', value: 'product', sortable: false },
        { text: 'Stay', value: 'stay', sortable: false },
        { text: 'Domain', value: 'domain', sortable: false },
        { text: 'Date', value: 'date', sortable: false },
      ],
    };
  },
  methods: {
    ...mapActions({
      openRequest: 'requestStatus/openRequest',
    }),
    getDomainName(id) {
      const domain = this.requests.domains.find(obj => obj.id === id);
      return domain ? domain.name : '';
    },
    getChannelName(id) {
      const channel = this.requests.channels.find(obj => obj.id === id);
      return channel ? channel.webservice : '';
    },
    getProductName(id) {
      const product = this.requests.products.find(obj => obj.id === id);
      return product ? product.tbName : '';
    },
    getRequestType(id) {
      const requestType = this.requests.requestTypes.find(obj => obj.id === id);
      return requestType ? requestType.label : 'ERROR';
    },
    getResponseDataMessage(responseData) {
      try {
        return JSON.parse(responseData).message;
      } catch (e) {
        return null;
      }
    },
    getStatusChip(status) {
      let returnValue = '';
      switch (status) {
        case 0:
          returnValue = { color: 'error', label: 'error' };
          break;
        case 1:
          returnValue = { color: 'warning', label: 'warning' };
          break;
        case 2:
          returnValue = { color: 'success', label: 'success' };
          break;
        case 3:
          returnValue = { color: 'light-blue', label: 'pending' };
          break;
        default:
          returnValue = { color: 'error', label: 'error' };
      }
      return returnValue;
    },
  },
  computed: {
    ...mapState({
      requests: state => state.requestStatus.requests,
    }),
  },
};
</script>

<template>
  <v-data-table
            :headers="headers"
            :items="requests.items"
            :loading="requests.loading"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:no-data>
              <tr>
                <td v-if="!requests.loading" colspan="8" class="text-xs-center">
                  {{
                    requests.noContent === false
                  ? 'Search for requests by using the filter'
                  : 'No content were found with that filter'
                  }}
                </td>
                <td v-if="requests.loading" colspan="8" class="text-xs-center">
                  Searching...
                </td>
              </tr>
            </template>
            <template v-if="!requests.noContent && !requests.loading" v-slot:items="request">
              <td>{{ request.item.id }}</td>
              <td>{{ getChannelName(request.item.xmlChannelId) }}</td>
              <td>{{ getRequestType(request.item.requestTypeId) }}</td>
              <td>
                <template
                  v-if="getResponseDataMessage(request.item.responseData)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip
                        :color="getStatusChip(request.item.status).color"
                        v-on="on"
                        text-color="white"
                      >
                        {{ getStatusChip(request.item.status).label }}
                      </v-chip>
                    </template>
                    <span>{{ getResponseDataMessage(request.item.responseData) }}</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  <v-chip
                    :color="getStatusChip(request.item.status).color"
                    text-color="white"
                  >
                    {{ getStatusChip(request.item.status).label }}
                  </v-chip>
                </template>
              </td>
              <td>
                {{
                  getProductName(
                    JSON.parse(request.item.requestData)['xml_channel_product_id']
                  )
                }}
              </td>
              <td>
                {{
                  request.item.bookingDetailId === '0'
                    ? ''
                    : request.item.bookingDetailId
                }}
                <br />
                {{formatDateSpecific(request.item.arrivalDate, 'DD-MM-YYYY' ,'No date') }}
                /
                {{ JSON.parse(request.item.requestData).nights }}
              </td>
              <td>{{ getDomainName(request.item.domainId) }}</td>
              <td>{{ formatDate(request.item.createdAt, 'No date')}}</td>
              <v-btn @click="openRequest(request.item)" color="primary" outline>
                Open
              </v-btn>
            </template>
  </v-data-table>
</template>



// WEBPACK FOOTER //
// src/components/requests/RequestsList.vue